import { createSlice } from '@reduxjs/toolkit';
import { IAcc } from '../../models/IProfile';

type ModalState = {
	balanceModal: { show: boolean },
	settingsModal: { show: boolean },
	settingsProfileModal: { show: boolean },
	bitrixModal: { show: boolean },
	confirmModal: { show: boolean },
	cacheModal: { show: boolean },
	id: string,
	accs: IAcc[],
};

const initialState: ModalState = {
	balanceModal: {
		show: false,
	},
	settingsModal: {
		show: false,
	},
	settingsProfileModal: {
		show: false,
	},
	bitrixModal: {
		show: false,
	},
	confirmModal: {
		show: false,
	},
	cacheModal: {
		show: false,
	},
	id: '',
	accs: [],
};

export const modalsSlice = createSlice({
	name: 'modals',
	initialState,
	reducers: {
		setBalanceModal: (state, data) => {
			state.balanceModal = data.payload;
		},
		setSettingsModal: (state, data) => {
			state.settingsModal = data.payload;
		},
		setSettingsProfileModal: (state, data) => {
			state.settingsProfileModal = data.payload;
		},
		setBitrixModal: (state, data) => {
			state.bitrixModal = data.payload;
		},
		setConfirmModal: (state, data) => {
			state.confirmModal = data.payload;
		},
		setCacheModal: (state, data) => {
			state.cacheModal = data.payload;
		},
		setId: (state, data) => {
			state.id = data.payload;
		},
		setAcc: (state, data) => {
			state.accs = data.payload;
		},
	},
});

export const {
	setBalanceModal,
	setSettingsModal,
	setSettingsProfileModal,
	setBitrixModal,
	setConfirmModal,
	setCacheModal,
	setId,
	setAcc,
} = modalsSlice.actions;

export default modalsSlice.reducer;
